import React from 'react';

// 页内二级标签（分段控件，样式与 BizSwitch 一致）。items: [[key, label], ...]
export default function SubTabs({ items, value, onChange, style }) {
  return (
    <div style={{ display: 'flex', gap: 6, padding: 4, background: 'var(--c-surface)', borderRadius: 12, boxShadow: 'var(--shadow-sm)', ...style }}>
      {items.map(([key, label]) => {
        const active = value === key;
        return (
          <button key={key} onClick={() => onChange(key)} style={{
            flex: 1, height: 34, borderRadius: 9, border: 'none', cursor: 'pointer',
            background: active ? 'var(--c-primary-light)' : 'transparent',
            color: active ? 'var(--c-primary)' : 'var(--c-text-secondary)',
            fontSize: 14, fontWeight: active ? 700 : 500, transition: 'all .15s',
          }}>{label}</button>
        );
      })}
    </div>
  );
}
